import { api, type ApiResponse } from './client';

export interface Category {
  uuid: string;
  name: string;
  description?: string;
  is_active?: boolean;
  sort_order?: number;
}

interface CategoryApiResponse {
  success: boolean;
  message: string;
  data: {
    categories: Category[];
  };
}

export const CategoryService = {
  /**
   * Get all categories for charity registration
   */
  getCategories: async (): Promise<{
    categories?: Category[];
    success: boolean;
    error?: any;
  }> => {
    try {
      const response = await api.get<CategoryApiResponse>('/resource-signup');
      
      if (response.data && response.data.success && response.data.data) {
        // Sort categories by sort_order
        const sortedCategories = response.data.data.categories
          .filter(category => category.is_active !== false)
          .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
        
        return {
          categories: sortedCategories,
          success: true
        };
      } else {
        return {
          success: false,
          error: 'Failed to fetch categories'
        };
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        success: false,
        error
      };
    }
  }
}; 